import Vue from 'vue';
export const commonTransfersHistoryTablesMixin = Vue.extend({
    methods: {
        handleChangeScrollPosition(v) {
            const vm = this;
            vm.scrolledDown = v > 0.9;
            if (v > 0.98) {
                this.$emit('onNextPage');
            }
        }
    }
});
